export default __webpack_public_path__ + "static/media/27-min.be5c3b89.jpg";